import styled from 'styled-components'
import {device} from '../../../theme'

export const CultureSection = styled.div `
    margin-top: 20px;
    @media ${device.small}{
        margin-top: 0;
    }
`;